import React, { useEffect, useRef, useState } from "react";
import Sremarque from "./Sremarque";
import recoSuggestions from "./recoSuggestions";
import RecoModal from "./RecoModal";
import { displayGrade } from "../../utils/grade";

const MAX_CHARS = 200;

const Smoyenne = ({
  moyenne,
  title,
  color,
  remarque,
  changeCarnetRemarque,
  changeModuleRemarque,
  general,
  unitInedx,
  unitName,
}) => {
  const [remarkOpen, setRemarkOpen] = useState(false);
  const [charCount, setCharCount] = useState((remarque || "").length);
  const [modalOpen, setModalOpen] = useState(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (general) return;
    if (initializedRef.current) return;
    if (remarque === undefined || remarque === null) return;
    initializedRef.current = true;
    if (remarque.trim() !== "" && remarque.trim() !== ".") {
      setRemarkOpen(true);
    }
  }, [remarque]);

  const suggestions = recoSuggestions[unitName] || [];

  if (!general) {
    return (
      <>
        <div style={{
          background: "#fffbeb",
          borderTop: "1px solid #fef3c7",
          padding: "8px 14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: remarkOpen ? 0 : "0 0 4px 4px",
        }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
            <span style={{ fontSize: 12, color: "#92400e", fontWeight: 500 }}>
              {title}
            </span>
            <span style={{
              fontSize: 18,
              color: "#111827",
              fontWeight: 600,
              fontVariantNumeric: "tabular-nums",
            }}>
              {displayGrade(moyenne)}
            </span>
          </div>
          <button
            type="button"
            className="remark-toggle"
            onClick={() => setRemarkOpen((v) => !v)}
            title={remarkOpen ? "Masquer la recommandation" : "Afficher la recommandation"}
          >
            <span className="chevron">{remarkOpen ? "▴" : "▾"}</span>
            <span>Recommandation du module</span>
          </button>
        </div>
        {remarkOpen && (
          <div style={{
            background: "#fffbeb",
            borderTop: "1px solid #fef3c7",
            padding: "10px 14px",
            borderRadius: "0 0 4px 4px",
          }}>
            <label style={{
              fontSize: 12,
              color: "#92400e",
              fontWeight: 500,
              display: "block",
              borderBottom: "1px solid #fef3c7",
              paddingBottom: 3,
              marginBottom: 4,
            }}>
              Recommandation du module :
            </label>
            <textarea
              value={remarque || ""}
              className="form-control"
              maxLength={MAX_CHARS}
              onChange={(e) => {
                setCharCount(e.target.value.length);
                changeModuleRemarque(unitInedx, e.target.value);
              }}
              placeholder="................................."
              style={{
                width: "100%",
                minHeight: 50,
                border: "1px solid #e5e7eb",
                borderRadius: 3,
                padding: "6px 8px",
                resize: "vertical",
                background: "white",
                fontSize: 13,
              }}
            />
            <div className={`remark-counter${charCount >= MAX_CHARS ? " danger" : charCount >= MAX_CHARS * 0.7 ? " warning" : ""}`}>
              {charCount} / {MAX_CHARS}
            </div>
            {suggestions.length > 0 && (
              <div style={{ marginTop: 8 }}>
                <div style={{ fontSize: 11, color: "#92400e", fontWeight: 500, marginBottom: 4, display: "flex", alignItems: "center", gap: 6 }}>
                  <span>💡 Suggestions fréquentes</span>
                  {suggestions.length > 4 && (
                    <button
                      type="button"
                      onClick={() => setModalOpen(true)}
                      style={{ background: "none", border: "none", cursor: "pointer", color: "#2563eb", fontSize: 13, padding: 0, fontWeight: 600, textDecoration: "underline", marginLeft: 8 }}
                    >
                      Voir tout ({suggestions.length})
                    </button>
                  )}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {suggestions.slice(0, 4).map((s, i) => (
                    <button
                      key={i}
                      type="button"
                      dir={/[؀-ۿ]/.test(s.text.charAt(0)) ? "rtl" : "ltr"}
                      onClick={() => {
                        changeModuleRemarque(unitInedx, s.text);
                        setCharCount(s.text.length);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                        padding: "3px 8px",
                        fontSize: 13,
                        fontWeight: 500,
                        background: "white",
                        border: "1px solid #d1d5db",
                        borderRadius: 12,
                        cursor: "pointer",
                        color: "#1f2937",
                        lineHeight: 1.4,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = "#fbbf24";
                        e.currentTarget.style.background = "#fef9c3";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = "#d1d5db";
                        e.currentTarget.style.background = "white";
                      }}
                    >
                      <span>{s.text}</span>
                      <span style={{ color: "#9ca3af", fontSize: 10 }}>· {s.freq}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {modalOpen && (
          <RecoModal
            suggestions={suggestions}
            onSelect={(text) => { changeModuleRemarque(unitInedx, text); setCharCount(text.length); setModalOpen(false); }}
            onClose={() => setModalOpen(false)}
          />
        )}
      </>
    );
  }

  return (
    <div style={{
      background: "white",
      border: "1px solid #e5e7eb",
      borderRadius: 4,
      padding: "14px 16px",
      marginBottom: 12,
    }}>
      <Sremarque
        general={general}
        unitInedx={unitInedx}
        color={color}
        remarque={remarque}
        changeCarnetRemarque={changeCarnetRemarque}
        changeModuleRemarque={changeModuleRemarque}
      />
    </div>
  );
};

export default Smoyenne;
